import React, { PropTypes, Component } from 'react';
import { bindActionCreators } from 'redux';

import { loginModel as model } from '../../../models/auth/login.model';
import { loginModelForm as modelForm } from '../../../models/auth/login.model.form';
import { clearError } from '../../../actions/common.actions';

export class LoginContainerCore extends Component {

    componentWillUnmount() {
        const { handleOnClearForm, handleClearError } = this.props;
        handleOnClearForm();
        handleClearError();
    }

    render() {
        return null;
    }
}

export const mapStateToPropsCore = (state, props) => {
    return {
        model,
        modelForm,
        modelData: state.auth[model.MODEL_NAME],
        formData: state.authForm[modelForm.MODEL_NAME],
        error: state.common.error
    };
};

export const mapDispatchToPropsCore = modelGet => dispatch => {
    return {
        handleOnClearForm: bindActionCreators(modelForm.actionOnClearForm.bind(null, modelForm), dispatch),
        handleOnValidate: bindActionCreators(modelForm.actionOnValidate.bind(null, modelForm), dispatch),
        handleSubmit: bindActionCreators(modelGet(model), dispatch),
        handleClearError: bindActionCreators(clearError, dispatch),

        handleOnChangeEmail: bindActionCreators(modelForm.actionOnChangeEmail.bind(null, modelForm), dispatch),
        handleOnChangePassword: bindActionCreators(modelForm.actionOnChangePassword.bind(null, modelForm), dispatch)
    };
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/containers/pages/auth/Login.container.js